import { QuerySwitch } from 'components/QuerySwitch';
import {
  LocationRecordDetailDataContext,
  LocationRecordDetailDataProvider,
} from 'pages/Settings/pages/LocationSettings/LocationRecordDetail.data.context';
import { PositionsAllocationSettingsPageForm } from 'pages/Settings/pages/LocationSettings/PositionsAllocation/PositionsAllocationSettingsPageForm';
import { FC } from 'react';

export const PositionsAllocationSettingsPage: FC = () => {
  return (
    <LocationRecordDetailDataProvider>
      <QuerySwitch
        context={LocationRecordDetailDataContext}
        component={PositionsAllocationSettingsPageForm}
      />
    </LocationRecordDetailDataProvider>
  );
};
